import state from './courseState'
import mutations from './courseMutations'
import getters from './courseGetters'
import actions from './courseActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
